<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>链理枝A——A股产业链知识图谱可视化项目</h1>
        </div>
        <div class="picture">
          <img src="../assets/project6_3.png.webp" />
        </div>
        <div class="abstract">
          产业知识图谱像草木一样具有生命力，不断生长又彼此相连。
          <br /><br />
          链理枝A的灵感正来源于此——这是一个供量化投研用户使用的可视化项目。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project6_1.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">全面的数据库</div>
        <div class="text">
          支持上下游产业链可视化展示，结构关系清晰，可逐级展开，便于投研人员快速理解产业关联。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="sub-title">实时抓取数据</div>
        <div class="text">
          即时展示成分股市值与涨跌变化，以可视化方式呈现市场状态，辅助高效决策。
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project6_2.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project6_4.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">31个申万一级行业全收录</div>
        <div class="text">
          采用申万宏源研究所发布的权威分类方法，实时读取产业链关系，支持从一级到三级上下游行业关系逐层展开。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="sub-title">A股行业开源数据库</div>
        <div class="text">
          收录A股行业开源数据库，可直观查看成分股与主营产品之间的关联关系。
        </div>
      </el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project6_5.png.webp" />
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="10">
        <div class="picture">
          <img src="../assets/project6_6.png.webp" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="sub-title">全图谱搜索与双模式切换</div>
        <div class="text">
          支持全图谱搜索并高亮节点，同时可在光合模式与深海模式之间自由切换（浅色与深色模式）。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project6Zh",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
.sub-title {
  margin-bottom: 20px;
  font-size: 18px;
  color: #333;
  font-weight: 400;
}
.text {
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.abstract {
  margin-top: 40px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 4px;
  color: #333333;
}
</style>